import { render, staticRenderFns } from "./CarouselRestaurant.vue?vue&type=template&id=eca70634&scoped=true&"
import script from "./CarouselRestaurant.vue?vue&type=script&lang=js&"
export * from "./CarouselRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./CarouselRestaurant.vue?vue&type=style&index=0&id=eca70634&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca70634",
  null
  
)

export default component.exports